import { useState } from "react";
import { toast } from "sonner";
import { Loader2, UserX } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, downloadFile } from "@/lib/api";

export const ClearAllDialog = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const close = () => { setOpen(false); setPassword(""); setConfirm(""); };

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const win = window.self !== window.top ? window.open("", "_blank") : undefined;
    try {
      const { data } = await api.post("/admin/startlist/clear", { password });
      try { await downloadFile({ path: `/admin/backups/${data.backup_id}/file.xlsx`, filename: data.filename, win }); }
      catch { toast.error("Nie udało się pobrać kopii wyników"); }
      toast.success(`Usunięto wszystkich zawodników (${data.deleted} występów)`);
      close();
      onDone();
    } catch (err) { win?.close(); toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  const ctl = "w-full h-11 px-3 rounded-xl bg-[#0B132B] border border-blue-500/20 focus:border-blue-500 outline-none text-sm mt-1";
  return (
    <>
      <button data-testid="clear-all-btn" onClick={() => setOpen(true)} className="h-11 px-4 rounded-xl border border-red-500/40 text-red-300 hover:bg-red-500/10 text-sm font-semibold uppercase tracking-wide flex items-center gap-2"><UserX className="w-4 h-4" />Usuń wszystkich zawodników</button>
      <Dialog open={open} onOpenChange={(v) => !v && close()}>
        <DialogContent className="bg-[#1C2541] border-red-500/40 max-w-md" data-testid="clear-all-dialog">
          <DialogHeader><DialogTitle className="font-display text-2xl uppercase text-red-300">Usuń wszystkich zawodników</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-300">Usunięta zostanie cała lista startowa (wszystkie występy), wszystkie oceny sędziów i cała rejestracja (obecność i ubezpieczenia). Kategorie, ceny, grupy wiekowe, użytkownicy i zgłoszenia zostają. Przed usunięciem pobierze się kopia wyników w Excelu. Tej operacji nie można cofnąć.</p>
            <label className="block text-xs text-slate-400">Wpisz USUŃ, aby potwierdzić
              <input data-testid="clear-all-confirm-input" value={confirm} onChange={(e) => setConfirm(e.target.value)} className={ctl} />
            </label>
            <label className="block text-xs text-slate-400">Hasło administratora
              <input data-testid="clear-all-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={ctl} autoComplete="current-password" />
            </label>
            <button data-testid="clear-all-confirm-btn" disabled={!password || confirm.trim().toUpperCase() !== "USUŃ" || busy} className="w-full h-11 rounded-xl bg-red-600 hover:bg-red-500 font-semibold disabled:opacity-40 flex items-center justify-center gap-2 uppercase tracking-wide">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />}Usuń wszystko
            </button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};
